export default __webpack_public_path__ + "static/media/Group 4.7f62233b.png";